export const name = 'viewerManagerVariantsApi' as const
export const VariantsApiSymbol = Symbol('VariantsApi')
